export default "__VITE_ASSET__CMKE2K77__"